import { useState } from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-flight-takeoff-line',
    title: 'Ekspres Kurye',
    sub: '24-72 Saat Teslimat',
    desc: 'Kapıdan kapıya ekspres teslimat. DHL, FedEx ve UPS entegrasyonuyla en avantajlı fiyatlar.',
    img: 'https://readdy.ai/api/search-image?query=3d%20render%20of%20cargo%20airplane%20flying%20above%20clouds%20at%20night%20with%20glowing%20orange%20trail%20light%20effects%2C%20dark%20background%2C%20cinematic%20lighting%2C%20futuristic%20logistics%20concept%2C%20ultra%20detailed%203d%20art&width=500&height=320&seq=s3d-exp&orientation=landscape',
    tag: 'Hızlı',
    path: '/hizmetler/ekspres-kurye-servisi',
  },
  {
    icon: 'ri-store-2-line',
    title: 'E-Ticaret Lojistiği',
    sub: 'Marketplace Entegrasyonu',
    desc: 'Amazon, Etsy, eBay otomatik entegrasyonu. Sipariş geldiği anda işleme alınır.',
    img: 'https://readdy.ai/api/search-image?query=3d%20render%20of%20floating%20package%20boxes%20with%20holographic%20screens%20and%20data%20streams%2C%20dark%20space%20background%2C%20orange%20glow%20effects%2C%20futuristic%20ecommerce%20logistics%20visualization%2C%20cinematic%203d%20art&width=500&height=320&seq=s3d-ecom&orientation=landscape',
    tag: 'Otomasyon',
    path: '/hizmetler/uluslararasi-e-ticaret-servisi',
  },
  {
    icon: 'ri-ship-line',
    title: 'Kargo Taşımacılığı',
    sub: 'Hava, Deniz & Kara',
    desc: 'FCL/LCL konteyner, hava charter ve TIR hizmetleriyle her ölçekte yük.',
    img: 'https://readdy.ai/api/search-image?query=3d%20render%20of%20container%20ship%20on%20dark%20ocean%20at%20night%20with%20orange%20glowing%20lights%20reflecting%20on%20water%2C%20cinematic%20aerial%20view%2C%20dramatic%20lighting%2C%20professional%203d%20visualization&width=500&height=320&seq=s3d-sea&orientation=landscape',
    tag: 'Global',
    path: '/hizmetler/uluslararasi-kargo-tasimaciligi',
  },
  {
    icon: 'ri-archive-2-line',
    title: 'Fulfillment',
    sub: '5.000 m² Depolama',
    desc: 'Ürün stoklama, paketleme ve kargolama tamamen bizde. Siz sadece satışa bakın.',
    img: 'https://readdy.ai/api/search-image?query=3d%20render%20of%20futuristic%20automated%20warehouse%20with%20robotic%20arms%20orange%20neon%20lighting%20conveyor%20belts%20moving%20packages%20dark%20industrial%20setting%20cinematic%203d%20art&width=500&height=320&seq=s3d-ful&orientation=landscape',
    tag: 'Depo',
    path: '/hizmetler/fulfillment',
  },
  {
    icon: 'ri-global-line',
    title: 'Mikro İhracat',
    sub: 'Kolay Gümrük',
    desc: '300 EUR\'ya kadar gümrüksüz ihracat. Elektronik beyanname ve hızlı onay.',
    img: 'https://readdy.ai/api/search-image?query=3d%20render%20of%20world%20globe%20with%20glowing%20orange%20trade%20route%20connections%20between%20countries%20dark%20background%20holographic%20data%20visualization%20professional%203d%20art&width=500&height=320&seq=s3d-global&orientation=landscape',
    tag: 'İhracat',
    path: '/hizmetler/mikro-ihracat-etgb',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Sigorta & A.TR',
    sub: 'Tam Güvence',
    desc: 'Her sevkiyat sigorta kapsamında. AB ülkeleri için A.TR belgesi hazırlığı.',
    img: 'https://readdy.ai/api/search-image?query=3d%20render%20of%20glowing%20shield%20with%20cargo%20box%20inside%2C%20dark%20background%20with%20orange%20energy%20particles%2C%20security%20protection%20concept%20for%20logistics%2C%20cinematic%203d%20visualization&width=500&height=320&seq=s3d-shield&orientation=landscape',
    tag: 'Güvence',
    path: '/hizmetler/sigorta',
  },
];

export default function ServicesSection() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section
      className="relative overflow-hidden"
      style={{ background: 'var(--bg2)', padding: '100px 0', borderTop: '1px solid var(--border)' }}
    >
      <div className="absolute pointer-events-none" style={{ top: '20%', right: '-10%', width: 500, height: 500, background: 'radial-gradient(circle, rgba(232,97,26,0.06) 0%, transparent 65%)', borderRadius: '50%' }}></div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <div>
            <div className="label"><div className="label-dot"></div>Hizmetlerimiz</div>
            <h2
              className="reveal h-font"
              style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px, 4.5vw, 56px)', color: 'var(--text1)', lineHeight: 1.1 }}
            >
              Lojistiğin Her<br />
              <span className="text-gradient">Boyutunda</span> Yanınızdayız
            </h2>
          </div>
          <div className="lg:max-w-sm">
            <p className="reveal d2 text-base leading-relaxed mb-5" style={{ color: 'var(--text2)' }}>
              8 hizmet kategorisi, tek platform, sıfır karmaşa.
            </p>
            <Link to="/hizmetler" className="reveal d3 inline-flex items-center gap-2 cursor-pointer" style={{ color: 'var(--orange)', fontWeight: 700, fontSize: 15 }}>
              Tümünü Gör <i className="ri-arrow-right-line bounce-x"></i>
            </Link>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((svc, i) => (
            <Link
              key={i}
              to={svc.path}
              className={`reveal d${Math.min(i + 1, 6)} cursor-pointer group block`}
              style={{
                background: hovered === i ? 'rgba(232,97,26,0.06)' : 'var(--surface)',
                border: `1px solid ${hovered === i ? 'rgba(232,97,26,0.25)' : 'var(--border)'}`,
                borderRadius: 20,
                overflow: 'hidden',
                transition: 'all 0.4s cubic-bezier(0.16,1,0.3,1)',
                transform: hovered === i ? 'translateY(-6px)' : 'translateY(0)',
                boxShadow: hovered === i ? '0 20px 60px rgba(0,0,0,0.2), 0 0 30px rgba(232,97,26,0.08)' : 'none',
                textDecoration: 'none',
              }}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
            >
              {/* Image */}
              <div style={{ height: 180, overflow: 'hidden', position: 'relative' }}>
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="w-full h-full object-cover transition-transform duration-700"
                  style={{ transform: hovered === i ? 'scale(1.06)' : 'scale(1)', objectPosition: 'center' }}
                />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, var(--overlay-dark) 0%, var(--overlay-light) 50%, transparent 100%)' }}></div>
                <div className="absolute top-3 left-3 tag-sm">{svc.tag}</div>
                <div
                  className="absolute bottom-3 left-3 w-9 h-9 flex items-center justify-center rounded-xl"
                  style={{ background: 'rgba(232,97,26,0.9)', boxShadow: '0 0 20px rgba(232,97,26,0.5)' }}
                >
                  <i className={`${svc.icon} text-white`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <h3 style={{ fontWeight: 800, fontSize: 16, color: 'var(--text1)', marginBottom: 4 }}>{svc.title}</h3>
                <p style={{ fontWeight: 600, fontSize: 12, color: 'var(--orange)', marginBottom: 8 }}>{svc.sub}</p>
                <p style={{ fontSize: 13, color: 'var(--text3)', lineHeight: 1.6 }}>{svc.desc}</p>
                <div
                  className="flex items-center gap-1.5 mt-4 text-sm"
                  style={{
                    color: 'var(--orange)',
                    fontWeight: 700,
                    transform: hovered === i ? 'translateX(4px)' : 'translateX(0)',
                    transition: 'transform 0.3s ease',
                  }}
                >
                  İncele <i className="ri-arrow-right-line" style={{ fontSize: 12 }}></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
